import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { exchangeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(user.role === "admin" ? "/admin" : user.role === "warehouse" ? "/admin/stock" : "/", {
          replace: true,
        });
      } catch {
        setError("Connexion Google impossible. Veuillez réessayer.");
      }
    })();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="grid min-h-screen place-items-center px-4" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-sm text-rose-600">{error}</p>
          <button type="button" className="ds-btn-primary mt-4" onClick={() => navigate("/connexion")}>
            Retour à la connexion
          </button>
        </div>
      ) : (
        <Loader2 className="h-7 w-7 animate-spin text-brand" />
      )}
    </div>
  );
}
